import api from './api';

const inmobiliariasService = {
  // Obtener todas las inmobiliarias
  getInmobiliarias: async (includeUnidades = false) => {
    try {
      const params = includeUnidades ? '?includeUnidades=true' : '';
      const response = await api.get(`/api/Inmobiliarias${params}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener inmobiliarias:', error);
      throw error;
    }
  },

  // Obtener una inmobiliaria por ID
  getInmobiliariaById: async (id) => {
    try {
      const response = await api.get(`/api/Inmobiliarias/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener inmobiliaria con ID ${id}:`, error);
      throw error;
    }
  },

  // Crear una nueva inmobiliaria
  createInmobiliaria: async (inmobiliariaData) => {
    try {
      // Validaciones
      if (!inmobiliariaData.name || inmobiliariaData.name.trim() === '') {
        throw new Error('El nombre es requerido');
      }
      
      if (!inmobiliariaData.email_inmobiliaria || inmobiliariaData.email_inmobiliaria.trim() === '') {
        throw new Error('El email es requerido');
      }

      // Validar formato de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inmobiliariaData.email_inmobiliaria)) {
        throw new Error('El formato del email no es válido');
      }

      if (inmobiliariaData.number_home !== undefined && inmobiliariaData.number_home < 0) {
        throw new Error('El número de propiedades no puede ser negativo');
      }

      if (inmobiliariaData.businness_price !== undefined) {
        const percentage = parseFloat(inmobiliariaData.businness_price);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          throw new Error('El porcentaje de negocio debe estar entre 0 y 100');
        }
      }

      const response = await api.post('/api/Inmobiliarias', inmobiliariaData);
      return response.data;
    } catch (error) {
      console.error('Error al crear inmobiliaria:', error);
      throw error;
    }
  },

  // Actualizar una inmobiliaria existente
  updateInmobiliaria: async (id, inmobiliariaData) => {
    try {
      // Validaciones
      if (inmobiliariaData.name !== undefined && inmobiliariaData.name.trim() === '') {
        throw new Error('El nombre no puede estar vacío');
      }

      if (inmobiliariaData.email_inmobiliaria !== undefined) {
        if (inmobiliariaData.email_inmobiliaria.trim() === '') {
          throw new Error('El email no puede estar vacío');
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inmobiliariaData.email_inmobiliaria)) {
          throw new Error('El formato del email no es válido');
        }
      }

      if (inmobiliariaData.number_home !== undefined && inmobiliariaData.number_home < 0) {
        throw new Error('El número de propiedades no puede ser negativo');
      }

      if (inmobiliariaData.businness_price !== undefined) {
        const percentage = parseFloat(inmobiliariaData.businness_price);
        if (isNaN(percentage) || percentage < 0 || percentage > 100) {
          throw new Error('El porcentaje de negocio debe estar entre 0 y 100');
        }
      }

      const response = await api.put(`/api/Inmobiliarias/${id}`, inmobiliariaData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar inmobiliaria con ID ${id}:`, error);
      throw error;
    }
  },

  // Eliminar una inmobiliaria
  deleteInmobiliaria: async (id) => {
    try {
      const response = await api.delete(`/api/Inmobiliarias/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar inmobiliaria con ID ${id}:`, error);
      throw error;
    }
  }
};

export default inmobiliariasService;
